import styled from 'styled-components';

export const ContainerTimer = styled.div`
  /* Auto layout */
  min-width: 280px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  gap: 32px;

  background: #ffffff;
  border-radius: 8px;
`;
